import { CourseServiceInterface } from 'domain/services';
import { GetAllCoursesUserUseCaseInterface } from 'domain/usecases';

export class CourseService implements CourseServiceInterface {
  constructor(
    private readonly _getAllCoursesUserUseCase: GetAllCoursesUserUseCaseInterface,
  ) {}

  async getAllCoursesUser(
    params: GetAllCoursesUserUseCaseInterface.Params,
  ): Promise<GetAllCoursesUserUseCaseInterface.Result> {
    return await this._getAllCoursesUserUseCase.execute(params);
  }
}
